import { UpCircleOutlined } from "@ant-design/icons";
import { Layout, Menu } from "antd";
import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ChatbotComponent from "../../components/chat-bot/ChatBotComponent";
import ScrollToTop from "../../hooks/ScrollToTop";
import { useViewport } from "../../hooks/useViewport";
import Header from "../header/Header";
import { menuItems } from "../sidebar/MenuItem";
import { AuthGuard } from "../../components/authentication/auth-guard";

export default function AuthPageNoFooter() {
  const location = useLocation();
  const { width } = useViewport();
  const isMobile = width <= 768;
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScroll]);

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 200) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 200) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <AuthGuard>
      <main>
        <Layout>
          <Header />
          <ScrollToTop />
          {isMobile && (
            <Menu
              mode="horizontal"
              defaultSelectedKeys={[location.pathname]}
              items={menuItems}
              className="menu-mobile"
            />
          )}
          <Layout style={{ minHeight: "calc(100vh - 370px)" }}>
            <Outlet />
          </Layout>
          <div className="scrollTop">
            <div
              onClick={scrollTop}
              className="scrollTopButton"
              style={{ display: showScroll ? "flex" : "none" }}
            >
              <UpCircleOutlined className="scroll-top-icon" />
            </div>
          </div>
        </Layout>
        {/* <ChatBotAssistant /> */}
        <ChatbotComponent />
      </main>
    </AuthGuard>
  );
}
